// extracted by mini-css-extract-plugin
export default {"root":"WelcomeTo__root","logoWrapper":"WelcomeTo__logoWrapper","brandLogo":"WelcomeTo__brandLogo"};